import Component from '@glimmer/component';

export default class MwCmsButton extends Component {}
